/** Reject explicit fixture provenance, never names or values in real business records. */
export function containsSimulatedData(value: unknown): boolean {
  if (Array.isArray(value)) return value.some(containsSimulatedData);
  if (!value || typeof value !== 'object') return false;
  const record = value as Record<string, unknown>;
  if (record.simulated === true || record.mocked === true) return true;
  const fixtureProviders = new Set(['simulated', 'simulated_bank', 'SIMULATED_FEED', 'S32_SEED_DATA']);
  if (typeof record.provider === 'string' && fixtureProviders.has(record.provider)) return true;
  if (typeof record.source === 'string' && fixtureProviders.has(record.source)) return true;
  if (record.selectedSourceProvider === 'simulated_bank') return true;
  return Object.values(record).some(containsSimulatedData);
}
